Foundation.Twitter = {};

Foundation.Twitter.cleanCookie = function () {
  return new Foundation.API("DELETE", "Twitter/Member")
}

// ---------------------------------------------------------------------

window["Foundation"]["Twitter"] = Foundation.Twitter

// ---------------------------------------------------------------------
